import styled from 'styled-components';
import {tableShimmer} from '../tableSetup/tableShimmerEffect';
export const tableRowSetup = (color) => {
    if (color === 'danger-light') {
        return `
            box-shadow: var(--shadow-danger-01);
            td {
                background: var(--${color});
            }
        `;
    } else if (color) {
        return `
            td {
                background: var(--${color});
            }
        `;
    } else {
        return ``;
    }
};

export const TableRow = styled.tr`
    border: none;
    border-radius: 4px;
    ${({shimmer}) => tableShimmer(shimmer)};
    ${({color}) => tableRowSetup(color)};
`;
